import React from "react";
import ReactDOM from "react-dom";
import { StyleProvider } from "@ant-design/cssinjs";
import { ConfigProvider } from "antd";
import { ThemeProvider, CssBaseline } from "@mui/material";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
// import 'antd/dist/antd.css';
import "react-notifications/lib/notifications.css";
import "./index.scss";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createTheme } from "@mui/material/styles";

// Suppress benign ResizeObserver loop errors (Ant Design + scroll tables)
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

window.addEventListener('error', (e) => {
  if (
    e.message?.includes('ResizeObserver') || 
    e.message?.includes('undelivered notifications') ||
    e.message?.includes('loop limit exceeded')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// Also catch unhandled promises that might contain these strings
window.addEventListener('unhandledrejection', (e) => {
  if (
    e.reason?.message?.includes('ResizeObserver') || 
    e.reason?.message?.includes('undelivered notifications')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const theme = createTheme({
  palette: {
    primary: {
      light: "#ff9a4d",
      main: "#ff6700",
      dark: "#cc5200",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,

    h1: { fontSize: "2.5rem", fontWeight: 700 },
    h2: { fontSize: "2rem", fontWeight: 700 },
    h3: { fontSize: "1.75rem", fontWeight: 600 },
    h4: { fontSize: "1.5rem", fontWeight: 600 },
    h5: { fontSize: "1.25rem", fontWeight: 600 },
    h6: { fontSize: "1.125rem", fontWeight: 600 },

    body1: { fontSize: "1rem" },
    body2: { fontSize: "0.875rem" },
  },
});

ReactDOM.render(
  <React.StrictMode>
    {/* <BrowserRouter> */}
    <ConfigProvider>
      <StyleProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </StyleProvider>
    </ConfigProvider>
    {/* </BrowserRouter> */}
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(params))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
